module.exports = require("froala-editor");